module.exports = __webpack_public_path__ + "img/dots_ldp_4.86a1976b.png";